var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotif26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 15.9953,
    viewBox: "0 0 32 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 0H16C7.16352 0 0 7.16143 0 15.9953H16C24.8365 15.9953 32 8.8339 32 0Z",
    fill: "#508FCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 7.99753H8.04045C3.59987 7.99753 5.28651e-06 11.5782 5.28651e-06 15.9952H7.95956C12.4003 15.9952 16 12.4145 16 7.99753Z",
    fill: "#D4623A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif26);
export default __webpack_public_path__ + "static/media/motif-26.27106d241155ad693efd4cca9fd49791.svg";
export { ForwardRef as ReactComponent };